export function resortListNative<T>(list: T[], fromIndex: number, toIndex: number): T[] {
  const result = [...list];
  const [movedItem] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, movedItem);
  return result;
}
